import { FarmdokColumnSettings } from '@/shared/handsontable/rework/types';

import { ColHeadersHook } from '../../types';

export default function colHeadersTitleFactory(tableColumns: FarmdokColumnSettings[]): ColHeadersHook {
  return function colHeaderTitle(index: number): string | undefined {
    return tableColumns[index].header && tableColumns[index].header?.title?.();
  };
}
